// "Horses" tab.
import type { ReactNode } from 'react';
import { TabPlaceholder } from './TabPlaceholder.js';

export function Horses(): ReactNode {
  return (
    <TabPlaceholder
      tabName="Horses"
      wiringNotes="Lists horses associated with the contact from the HubSpot horse object, with editor for name, age, and diet notes. Reads via the runtime read path (contract owned by services/hubspot-contact-source)."
    />
  );
}
